export const privacySections = {
  ru: [
    {
      h: 'Общие положения',
      p: 'Настоящая политика описывает обработку персональных данных при использовании сайта-портфолио (далее — «Сайт»). Обработка осуществляется в соответствии с Регламентом (ЕС) 2016/679 (GDPR) и применимым законодательством Чешской Республики.',
    },
    {
      h: 'Администратор данных',
      p: 'Администратором персональных данных является: Юсиф Мамедов (индивидуальная предпринимательская деятельность / фриланс), место нахождения: Прага, Чешская Республика. Контакт для вопросов по данным: usifmamedov5@gmail.com.',
    },
    {
      h: 'Какие данные обрабатываются',
      p: 'При просмотре Сайта технически могут обрабатываться данные о соединении (например, IP-адрес, тип браузера, время запроса) — на основании законного интереса обеспечения безопасности и стабильной работы Сайта. При отправке формы обратной связи обрабатываются указанные вами имя, адрес электронной почты, тип проекта и текст сообщения — на основании вашего согласия и/или шагов, необходимых до заключения договора по вашему запросу.',
    },
    {
      h: 'Форма обратной связи и Telegram',
      p: 'Сообщения, отправленные через форму, передаются в мессенджер Telegram для обработки запроса. Это может подразумевать передачу данных третьей стороне (оператору связи / платформе Telegram) и обработку за пределами ЕЭЗ. Передача осуществляется только в объёме, необходимом для ответа на обращение. Рекомендуем ознакомиться с политикой конфиденциальности Telegram.',
    },
    {
      h: 'Файлы cookie и аналитика',
      p: 'Сайт может использовать технически необходимые cookie для работы интерфейса. Статистические и маркетинговые инструменты (в т.ч. Google Tag Manager и связанные с ним теги) подключаются только после вашего явного согласия через баннер cookie. Вы можете отозвать согласие, очистив сохранённые настройки в браузере и снова выбрав параметры на Сайте (раздел настроек cookie в подвале).',
    },
    {
      h: 'Сроки хранения',
      p: 'Данные из формы обрабатываются в течение срока, необходимого для ответа на запрос, и при необходимости дольше — при наличии законного основания (например, ведение переписки по проекту, бухгалтерские или налоговые обязательства). Логи и аналитические данные хранятся в сроки, определяемые используемыми сервисами и вашими настройками согласия.',
    },
    {
      h: 'Ваши права',
      p: 'Вы имеете право на доступ, исправление, удаление, ограничение обработки, переносимость данных, возражение против обработки по законному интересу (при соответствующих условиях), а также право подать жалобу в надзорный орган (в ЧР: Úřad pro ochranu osobních údajů). Для реализации прав обратитесь по адресу usifmamedov5@gmail.com.',
    },
  ],
  en: [
    {
      h: 'General',
      p: 'This policy describes how personal data is processed when you use this portfolio website (the “Site”). Processing is carried out in accordance with Regulation (EU) 2016/679 (GDPR) and applicable law in the Czech Republic.',
    },
    {
      h: 'Data controller',
      p: 'The controller of your personal data is: Yosef Mamedov (freelance / sole trader activity), located in Prague, Czech Republic. Contact for privacy matters: usifmamedov5@gmail.com.',
    },
    {
      h: 'Data we process',
      p: 'When you browse the Site, technical data such as IP address, browser type and request time may be processed to ensure security and stable operation — based on legitimate interests. When you submit the contact form, we process the name, email, project type and message you provide — based on your consent and/or steps prior to a contract at your request.',
    },
    {
      h: 'Contact form and Telegram',
      p: 'Messages sent via the form are delivered to Telegram to handle your request. This may involve transferring data to third-party providers and processing outside the EEA. Only the data needed to respond to your enquiry is transferred. We encourage you to review Telegram’s privacy policy.',
    },
    {
      h: 'Cookies and analytics',
      p: 'The Site may use strictly necessary cookies for basic functionality. Statistics or marketing tools (including Google Tag Manager and related tags) are loaded only after you explicitly consent via the cookie banner. You can withdraw consent by clearing site data and revisiting the cookie settings link in the footer.',
    },
    {
      h: 'Retention',
      p: 'Form data is kept for as long as needed to answer your request and, where applicable, for legal obligations (e.g. accounting). Analytics data is retained according to the relevant services and your consent settings.',
    },
    {
      h: 'Your rights',
      p: 'You have the right to access, rectification, erasure, restriction, data portability, and to object to processing based on legitimate interests where applicable. You may lodge a complaint with a supervisory authority (in the Czech Republic: ÚOOÚ). To exercise your rights, contact usifmamedov5@gmail.com.',
    },
  ],
  he: [
    {
      h: 'כללי',
      p: 'מדיניות זו מתארת את עיבוד המידע האישי בשימוש באתר התיק עבודות (“האתר”). העיבוד נעשה בהתאם לתקנות (EU) 2016/679 (GDPR) ולדין החל בצ׳כיה.',
    },
    {
      h: 'בקר המידע',
      p: 'בקר המידע: יוסף ממדוב (עצמאי), מיקום: פראג, צ׳כיה. לפניות בנושא פרטיות: usifmamedov5@gmail.com.',
    },
    {
      h: 'אילו נתונים מעובדים',
      p: 'בגלישה באתר עשויים להתעבד נתונים טכניים (כתובת IP, דפדפן, זמן בקשה) למטרות אבטחה ויציבות — על בסיס עניין לגיטימי. בטופס יצירת קשר מעובדים שם, אימייל, סוג פרויקט והודעה — על בסיס הסכמתך ו/או צעדים לפני חוזה לפי בקשתך.',
    },
    {
      h: 'טופס וטלגרם',
      p: 'הודעות מהטופס נשלחות לטלגרם לטיפול בפנייה. ייתכן העברה לצד שלישי ועיבוד מחוץ ל-EEA, בכפוף לצורך במענה. מומלץ לעיין במדיניות הפרטיות של טלגרם.',
    },
    {
      h: 'עוגיות ואנליטיקה',
      p: 'האתר עשוי להשתמש בעוגיות הכרחיות. כלי אנליטיקה (כולל Google Tag Manager) נטענים רק לאחר הסכמה מפורשת בבאנר. ניתן לבטל הסכמה דרך הגדרות העוגיות בתחתית האתר.',
    },
    {
      h: 'שמירה',
      p: 'נתוני הטופס נשמרים ככל הנדרש למענה ולמטרות חוקיות. אנליטיקה לפי שירותים והסכמה.',
    },
    {
      h: 'זכויותיך',
      p: 'זכות לעיון, תיקון, מחיקה, הגבלה, ניידות, התנגדות ותלונה בפני רשות פיקוח (בצ׳כיה: ÚOOÚ). פנייה: usifmamedov5@gmail.com.',
    },
  ],
};
